<template>
  <div class='BtnImgs'>
    <button @click="Select"
    :style="{
      backgroundColor: Prefes.btnProduto.corBackground,
      color: Prefes.btnProduto.corFont,
      fontFamily: Prefes.btnProduto.font
    }"
    >
      Ver Fotos
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'BtnImgs',
  props: ['data'],
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    }
  }
}
</script>

<style scoped>
.BtnImgs {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
}

button {
  border: 0;
  background-color: orange;
  padding: 2%;
  border-radius: 8px;
  cursor: pointer;
}
</style>
